import { APIv4 as API } from 'src/libs/axios';
import { OptionFull } from '../../../../components/MainPage/_shared/Options';

export type CommonViewProduct = {
  id: number;
  name: string;
  position: number;
  isActive: boolean;
  variants: {
    id: number;
    isActive: boolean;
    options: OptionFull[];
  }[];
};

export const fetchCommonViewProducts = (params?: {
  skipVariants?: boolean;
}): Promise<CommonViewProduct[]> =>
  API.get(`/products/common-view`, { params }).then(
    (response) => response.data
  );
